<template>
    <l-tooltip :options="options">
        <div class="map-tooltip">
            <h4 class="window__title">{{cutString(title, 70)}}</h4>
        </div>
    </l-tooltip>
</template>
<script>
import L from "leaflet";
import { LTooltip } from "vue2-leaflet";
export default {
    name: 'm-popup',
    data() {
        return {
            options: {
                permanent: this.getZoom,
                direction: 'top',
                offset: L.point(0, -20)
            }
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        zoom: {
            type: Number,
            required: false,
            default: null
        }
    },
    components: {
        "l-tooltip": LTooltip
    },
    computed: {
        getZoom() {
            return this.zoom && this.zoom > 10
        }
    },
    methods: {
        cutString(val, length) {
            if (val) {
                val = val.toString();
                val = val.length > length ? val.slice(0, length).concat("...") : val;
            }
            return val;
        }
    }
}
</script>
<style lang="stylus">
.leaflet-tooltip
    padding 0
    border 0
    background-color white
    border-radius 10px
    padding 5px 10px
    padding-top 7px
    &:before
        display none
.leaflet-tooltip-right
    margin-left 28px !important
.leaflet-tooltip-left
    margin-right 36px !important
</style>